// Filename - components/Header.js

import { AppBar, Button, Link, Toolbar, Typography } from "@mui/material";
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';

import React from "react";
import logo from "../logo.svg";
import ResponsiveNavbar from "./ResponsiveNavBar";

import {
	Container,
	Row,
	Col,
	Form,
	Input,


	NavbarBrand,
	NavLink,
	NavItem,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from "react-bootstrap";


// const Header = () => (
// 	<header>

// <ResponsiveNavbar />
// </header>
// )


// export default Header;

const Header = () => {
	const rightStyle = {
		width: '30%',

		padding: '10px',
		float: 'right',
		boxSizing: 'border-box'
	};

	return (
		<AppBar position="static" color="primary">
			<Toolbar>
				<Typography variant="h4" style={{ flexGrow: 1 }}>
					SETHU-AI
				</Typography>
				<Navbar>
					<div style={rightStyle} >
						<Navbar.Toggle aria-controls="basic-navbar-nav" />
						<Navbar.Collapse id="basic-navbar-nav">
							<Nav className="me-auto">
								<Nav.Link href="/"><Typography variant="h6" style={{ color: '#Fff', backgroundColor: 'none', textDecoration: 'none', flexGrow: 1 }}>Home</Typography></Nav.Link>
								<Nav.Link href="/UseCases"><Typography variant="h6" style={{ color: '#Fff', backgroundColor: 'none', textDecoration: 'none', flexGrow: 1 }}>UseCases</Typography></Nav.Link>
								<Nav.Link href="/DemoCards"><Typography variant="h6" style={{ color: '#Fff', backgroundColor: 'none', textDecoration: 'none', flexGrow: 1 }}>Demo</Typography></Nav.Link>

							</Nav>
						</Navbar.Collapse>
					</div>

				</Navbar>



			</Toolbar>
		</AppBar>
	)
}
export default Header;
